if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const formData = new FormData(this.form);
      const sections = ['stmt-popout-cart-delivery-banner', 'stmt-popout-cart-items', 'stmt-popout-cart-footer'];
      const multiVariantSelector = this.form.querySelector('.item-submission');
      
      //Age Validation
      let ageValidation = false;
      if(this.form.querySelector('.js-age-restricted-check')){
        ageValidation = this.form.querySelector('.js-age-restricted-check').value;
      } else {
        ageValidation = false;
      }

      if(ageValidation == "true" && window.getCookie('ageOver16') != 'true'){
        document.dispatchEvent(new CustomEvent('age-validation:show'));
      } else {

        if(multiVariantSelector){

          // Ability to add multiple variants to the cart based on a "checklist" style add to cart form
          let items = [];
          let rows = evt.currentTarget.querySelectorAll('.item-submission');
      
          for(let i=0; i<rows.length; i++) {
            let itemData = rows[i];
            let id = parseInt(itemData.querySelector('[name="id"]').value );
            let qty = parseInt(itemData.querySelector('[name="quantity"]').value );
            if(id && qty > 0){
              items.push({ id: id, quantity: qty });
            }
          }
          if(!items.length){
            return;
          }
      
          return fetch('/cart/add.js', {
             method: 'POST',
             body: JSON.stringify({ items: items, sections: sections }),
             headers: { 'Content-type': 'application/json' },
             credentials: 'include'
           })
           .then(res => {
             return res.json();
           })
           .then((res) => {
              fetch(`${routes.cart_url}.json`)
              .then((res) => {
                return res.json();
              })
              .then((cart) => {
                fetch(`/?sections=${sections}`)
                .then((res) => {
                  return res.text();
                })
                .then((section) => {

                  document.dispatchEvent(
                    new CustomEvent('popout-cart:show')
                  );

                
                  document.dispatchEvent(
                    new CustomEvent('cart:requestComplete', { 
                      detail: {
                        data: {
                          ...cart,
                          sections: JSON.parse(section)
                        }
                      }
                    })
                  )

                })
              })
           })
           .catch((error) => {
             console.error('Error:', error);
          });
        } else {
          // Standard add to cart form submission
          document.dispatchEvent(
            new CustomEvent('cart:add', { 
              detail: {
                data: { formData: formData, max: 99, sections: sections }
              }
            })
          )
        }


        document.dispatchEvent(new CustomEvent('popout-cart:show'));
      }

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
